


















































































import Vue from 'vue';
import { OrganisationService } from '@/services/OrganisationService';
import { OrganisationModel } from '@/types/models/organisation';
import { EntityType, ErrorModel, NotificationPresentationType } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation, ModalHelpers } from '@/mixins';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'EditOrganisation',
  mixins: [FormFieldValidation, ModalHelpers],
  data() {
    return {
      organisation: {} as OrganisationModel,
      isLoading: false,
      submitIsLoading: false,
      activeChecked: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    getOrganisation(this: any) {
      this.isLoading = true;
      OrganisationService.getOrganisationAsync(this.$route.params.id)
        .then((result: any) => {
          if (result && !result.canEdit) {
            this.$router.push({
              name: 'errorPage',
              params: {
                errorCode: '401',
                errorMessage: 'Sorry, you do not have permission to edit this organisation.',
                notificationPresentationType: NotificationPresentationType.UserActionRequired.toString()
              }
            });
          }
          this.organisation = result;
          this.activeChecked = !this.organisation.isDeactivated;
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.isLoading = false;
          this.hasError = true;
          this.errorMessage = error.notification;
        });
    },
    onSubmit(this: any) {
      this.submitIsLoading = true;
      this.organisation.isDeactivated = !this.activeChecked;
      OrganisationService.updateOrganisationAsync(this.organisation.id, this.organisation)
        .then((response) => {
          SnotifyConfiguration.showSuccess('Organisation successfully updated.');
          this.submitIsLoading = false;
          this.setApplicationDirty(false);
          this.$router.push({ name: 'organisationManagement' });
        })
        .catch((error) => {
          this.$validator.errors.remove('serverValidationErrors');
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
          this.submitIsLoading = false;
        });
    },
    async cancel(this: any) {
      this.$router.push({ name: 'organisationManagement' });
    }
  },
  mounted(this: any) {
    this.getOrganisation();
  },
  components: {
    LoadingSpinner
  }
});
